/** @jsx jsx */
import { jsx, Styled } from "theme-ui"
import PropTypes from "prop-types"

const Blue = props => (
  <Styled.p
    {...props}
    sx={{
      color: "primary",
      fontWeight: "bold",
      ...props.sx,
    }}
  >
    {props.children}
  </Styled.p>
)

Blue.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.any,
}

export default Blue
